import { render, staticRenderFns } from "./StoreButtons.vue?vue&type=template&id=5ef70b28&"
import script from "./StoreButtons.vue?vue&type=script&lang=js&"
export * from "./StoreButtons.vue?vue&type=script&lang=js&"
import style0 from "./StoreButtons.vue?vue&type=style&index=0&id=5ef70b28&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports